import * as S from './styles';

declare type TitleProps = {
    title?: string;
}

export default function Title({ title }: TitleProps) {
    return (
        <S.Container>
            <S.Title>{title}</S.Title>
        </S.Container>
    )
}